import { render, staticRenderFns } from "./committeeCommunityManageList.vue?vue&type=template&id=1a2ac87f&scoped=true"
import script from "./committeeCommunityManageList.vue?vue&type=script&lang=js"
export * from "./committeeCommunityManageList.vue?vue&type=script&lang=js"
import style0 from "./committeeCommunityManageList.vue?vue&type=style&index=0&id=1a2ac87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ac87f",
  null
  
)

export default component.exports